export default {
    schedules: {},
    sendNowBroadcastId: null,
    statuses: {},
};
